// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutfirstpage-mainabout-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  min-height: calc(100vh - nav-height);
  margin-top: 80px;
}

.aboutfirstpage-image-section {
  width: 60%;
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.aboutfirstpage-mainabout-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.aboutfirstpage-text-section {
  width: 85%;
  background-color: #2faac6;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -6%;
}

.aboutfirstpage-mainabout-container::before {
  content: "";
  position: absolute;
  z-index: 2;
  background: linear-gradient(to bottom right, #2faac6, rgba(214, 215, 219, 0));
  pointer-events: none;
  left: 40%;
  width: 3.5%;
  height: 150%;
  top: -25%;
  transform: skewX(-8deg) translate(-5px, 10px);
}

.aboutfirstpage-text-section h1 {
  font-size: 3em;
  margin-bottom: 10px;
  z-index: 3;
  font-family: Arial, Helvetica, sans-serif;
}

.aboutfirstpage-text-section p {
  font-size: 1.4em;
  text-align: center;
  padding: 0 20px;
  z-index: 3;
}

.aboutfirstpage-container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}

.aboutfirstpage-image-wrapper {
  flex: 1 1;
}

.aboutfirstpage-image {
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
}

.aboutfirstpage-text-wrapper {
  flex: 2 1;
  padding: 10px;
}

.aboutfirstpage-info-section {
  margin: 20px 0;
}

.aboutfirstpage-about-right {
  text-align: center;
  width: 100%;
  height: 100%;
}

.aboutfirstpage-about-right h1 {
  text-align: left;
  margin-left: 10%;
  color: black;
  margin-bottom: 3%;
  margin-top: 2%;
}

.aboutfirstpage-about-right h2 {
  text-align: left;
  color: #010d0f;
  margin-left: 10%;
}

.aboutfirstpage-about-right p {
  text-align: left;
  margin-left: 10%;
  font-size: 18px;
  margin-right: 10%;
}

.aboutfirstpage-about-right ul {
  text-align: left;
  margin-left: 10%;
  gap: 50px;
  margin-bottom: 5%;
}

.aboutfirstpage-ul li {
  margin-bottom: 5px;
  margin-left: 0px;
}

@media (max-width: 768px) {
  .aboutfirstpage-mainabout-container {
    flex-direction: column;
    height: 85vh;
  }

  .aboutfirstpage-image-section {
    width: 100%;
    height: 80%;
    clip-path: none;
  }

  .aboutfirstpage-text-section {
    width: 100%;
    height: 80%;
    margin-left: 0;
    text-align: left;
    clip-path: none;
    padding: 20px;
    gap: 10px;
  }
  .aboutfirstpage-text-section h1 {
    font-size: 2.5em;
    margin-bottom: 140px;
    margin-left: -200px;
    z-index: 3;
    text-align: left;
    font-family: Arial, Helvetica, sans-serif;
  }

  .aboutfirstpage-text-section p {
    font-size: 1.2em;
    text-align: left;

    z-index: 3;
    margin-top: -140px;

    margin-left: -10px;
  }
  .aboutfirstpage-mainabout-container::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainAbout/MainAbout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,6EAA6E;EAC7E,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;;IAEhB,UAAU;IACV,kBAAkB;;IAElB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".aboutfirstpage-mainabout-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  min-height: calc(100vh - nav-height);\n  margin-top: 80px;\n}\n\n.aboutfirstpage-image-section {\n  width: 60%;\n  position: relative;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n.aboutfirstpage-mainabout-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.aboutfirstpage-text-section {\n  width: 85%;\n  background-color: #2faac6;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n  margin-left: -6%;\n}\n\n.aboutfirstpage-mainabout-container::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  background: linear-gradient(to bottom right, #2faac6, rgba(214, 215, 219, 0));\n  pointer-events: none;\n  left: 40%;\n  width: 3.5%;\n  height: 150%;\n  top: -25%;\n  transform: skewX(-8deg) translate(-5px, 10px);\n}\n\n.aboutfirstpage-text-section h1 {\n  font-size: 3em;\n  margin-bottom: 10px;\n  z-index: 3;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.aboutfirstpage-text-section p {\n  font-size: 1.4em;\n  text-align: center;\n  padding: 0 20px;\n  z-index: 3;\n}\n\n.aboutfirstpage-container {\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n\n.aboutfirstpage-image-wrapper {\n  flex: 1;\n}\n\n.aboutfirstpage-image {\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n}\n\n.aboutfirstpage-text-wrapper {\n  flex: 2;\n  padding: 10px;\n}\n\n.aboutfirstpage-info-section {\n  margin: 20px 0;\n}\n\n.aboutfirstpage-about-right {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n}\n\n.aboutfirstpage-about-right h1 {\n  text-align: left;\n  margin-left: 10%;\n  color: black;\n  margin-bottom: 3%;\n  margin-top: 2%;\n}\n\n.aboutfirstpage-about-right h2 {\n  text-align: left;\n  color: #010d0f;\n  margin-left: 10%;\n}\n\n.aboutfirstpage-about-right p {\n  text-align: left;\n  margin-left: 10%;\n  font-size: 18px;\n  margin-right: 10%;\n}\n\n.aboutfirstpage-about-right ul {\n  text-align: left;\n  margin-left: 10%;\n  gap: 50px;\n  margin-bottom: 5%;\n}\n\n.aboutfirstpage-ul li {\n  margin-bottom: 5px;\n  margin-left: 0px;\n}\n\n@media (max-width: 768px) {\n  .aboutfirstpage-mainabout-container {\n    flex-direction: column;\n    height: 85vh;\n  }\n\n  .aboutfirstpage-image-section {\n    width: 100%;\n    height: 80%;\n    clip-path: none;\n  }\n\n  .aboutfirstpage-text-section {\n    width: 100%;\n    height: 80%;\n    margin-left: 0;\n    text-align: left;\n    clip-path: none;\n    padding: 20px;\n    gap: 10px;\n  }\n  .aboutfirstpage-text-section h1 {\n    font-size: 2.5em;\n    margin-bottom: 140px;\n    margin-left: -200px;\n    z-index: 3;\n    text-align: left;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n\n  .aboutfirstpage-text-section p {\n    font-size: 1.2em;\n    text-align: left;\n\n    z-index: 3;\n    margin-top: -140px;\n\n    margin-left: -10px;\n  }\n  .aboutfirstpage-mainabout-container::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
